// extracted by mini-css-extract-plugin
export default {"terms_of_use_container":"TermsOfUse_terms_of_use_container__1NvuN","title":"TermsOfUse_title__iu9nK","strong_caps_text":"TermsOfUse_strong_caps_text__upYMo"};